import { useState } from 'react';

import { ResourceCostChartWidget } from './_components/ResourceCostChartWidget';
import { useWorkloadResourceCostChartData } from './_hooks/useWorkloadResourceCostChartData';
import { STORAGE_FIELDS } from './constants';

const STORAGE_COST_TOOLTIP_TEXT =
  'Cost per requested GB based on storage compute spend divided by requested storage GB.';

export const StorageCostChartWidget = () => {
  const [costRate, setCostRate] = useState<'hourly' | 'daily' | 'monthly'>(
    'daily'
  );
  const {
    data,
    averageCost,
    isLoading,
    error,
    refetch,
    timeZone,
    isRangeSupported,
  } = useWorkloadResourceCostChartData(costRate, STORAGE_FIELDS);

  return (
    <ResourceCostChartWidget
      title="Storage cost"
      testId="storage-cost-card"
      metricLabel="Cost per requested GB"
      metricInfoTooltip={STORAGE_COST_TOOLTIP_TEXT}
      metricTestId="storage-cost-metrics-box"
      failedToLoadTitle="Failed to load storage cost"
      hasOfferingBreakdown={false}
      costRate={costRate}
      onCostRateChange={setCostRate}
      data={data}
      averageCost={averageCost}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      timeZone={timeZone}
      isRangeSupported={isRangeSupported}
      chartTestId="storage-cost-chart"
      tooltipTestId="storage-cost-tooltip"
      unsupportedRangeTestId="storage-cost-card-unsupported-range"
    />
  );
};
